import { useSelector } from "react-redux";
import apiClient from "../api/client";

/**
 * Custom hook to manage authenticated API requests and access the current user information.
 * @hook
 * @author Priyanshu
 */

export default function useAuth() {
  const { user } = useSelector((state: any) => state.user);
  const userId = user?.userId || null;

  return {
    request: apiClient,
    userId,
  };
}
